import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Utility } from 'app/shared';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss']
})
export class LanguageComponent implements OnInit {

  public languageOptions: any;
  public selectedLanguage: any;

  constructor(public _translateService: TranslateService) {
    this.languageOptions = Utility.languageOptions;
  }

  ngOnInit(): void {
  }

  setLanguage(language: any): void {
    // Set the selected language for the navbar on change
    this.selectedLanguage = language;

    // Use the selected language id for translations
    this._translateService.use(language);
  }
}
